<template>
  <Swiper
    :modules="modules"
    :slides-per-view="1"
    :space-between="16"
    :speed="600"
    :grab-cursor="true"
    :parallax="true"
    :pagination="{ clickable: true }"
    :breakpoints="{
      1024: {
        direction: 'vertical',
        centeredSlides: true,
        centeredSlidesBounds: true,
        centerInsufficientSlides: true
      }
    }"
    class="multiple-swiper relative m-0 mx-auto h-auto w-full p-0 text-left lg:h-[50vh] lg:min-h-[640px]"
  >
    <SwiperSlide v-for="(item, idx) in data" :key="idx" class="lg:!flex lg:!flex-col lg:!justify-center">
      <div class="grid-default px-4 lg:px-0">
        <div class="col-span-6">
          <div class="flex flex-col gap-3 lg:flex-row lg:gap-14">
            <div class="text-2xl font-medium text-orange lg:mt-3">
              {{ String(idx + 1).padStart(2, '0') }}
            </div>
            <Heading v-if="item.heading" semantic class="mb-6 text-3xl text-blue-950 lg:mb-16 lg:text-6xl">
              {{ item.heading }}
            </Heading>
          </div>
          <div
            v-if="item.descriptionText"
            class="mb-6 text-xl text-neutral-500 lg:mb-16 lg:text-2xl lg:ml-20"
            v-html="item.descriptionText"
          />
          <div class="mb-6 flex gap-6 text-lg text-neutral-700 lg:mb-0 lg:gap-8 lg:text-2xl lg:ml-20">
            <NuxtLink
              v-for="(link, index) in item.links"
              :key="index"
              :to="localePathByType(link.__typename as string, link.slug as string)"
              class="hover:underline"
            >
              {{ link.title }}
            </NuxtLink>
          </div>
        </div>
        <div class="col-span-6">
          <Image
            v-if="item.image"
            class="mx-auto aspect-square rounded-full"
            :src="item.image.responsiveImage ? item.image.responsiveImage?.src : item.image.url"
            :srcset="
              item.image.responsiveImage ? item.image.responsiveImage?.webpSrcSet : undefined
            "
            :width="
              item.image.responsiveImage ? item.image.responsiveImage?.width : item.image.width
            "
            :height="
              item.image.responsiveImage ? item.image.responsiveImage?.height : item.image.height
            "
            :sizes="item.image.responsiveImage?.sizes"
            :alt="item.image?.alt!"
          />
        </div>
      </div>
    </SwiperSlide>
  </Swiper>
</template>

<script setup lang="ts">
import { Parallax, A11y, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { MultipleRecord } from '~/types/generated'

import 'swiper/css'
import 'swiper/css/pagination'

const modules = [Parallax, A11y, Pagination]
const { localePathByType } = useLocalePathByType()

defineProps({
  data: {
    type: Object as PropType<MultipleRecord[]>,
    default: () => {}
  }
})
</script>

<style lang="postcss">
.multiple-swiper .swiper-pagination {
  @apply !top-1 !right-4 lg:!left-0 lg:!right-auto lg:!top-28 lg:h-fit;
}
</style>
